import HelperRemoveNullValues from "./remove-null-values.helper";

export const HelperCreateQuery = (
  object: any,
  opt?: {
    encodeArray?: boolean;
  }
) => {
  const params = HelperRemoveNullValues(object, {
    removeEmptyArray: true,
    removeEmptyStrings: true
  });
  if (params === null || params === undefined) return "";

  if (opt?.encodeArray) {
    Object.keys(params).forEach(key => {
      if (Array.isArray(params[key])) {
        params[key].forEach((item: any, index: any) => {
          params[`${key}[${index}]`] = item;
        });
        delete params[key];
      }
    });
  }

  return Object.keys(params).length === 0
    ? ""
    : `?${new URLSearchParams(params).toString()}`;
};
